export default __webpack_public_path__ + "static/media/sw_6.015ae91c.png";